import useGetProductPriceRangeNearByMe from './useGetProductPriceRangeNearByMe'

export default useGetProductPriceRangeNearByMe
